import type { GoOfflineConfig } from "../../src/types";

export function generateConfigFile(config: GoOfflineConfig): string {
  return `import { defineOfflineConfig } from "go-offline";

export default defineOfflineConfig(${JSON.stringify(config, null, 2)});
`;
}
